import { Box, Card } from '@material-ui/core';
import React, { FC } from 'react';
import { FormTab, TabbedForm } from 'react-admin';
import CompetitionTable from './CompetitionTable';

const CompetitionsList: FC = () => {
  return (
    <>
      <Box marginTop='2em'>
        <div className='active-prizes-container'>Competitions</div>
        <Box display='flex' justifyContent='flex-end'></Box>
      </Box>
      <Box marginTop='0.5em'>
        <Card>
          <TabbedForm toolbar={<></>} className='user-tabs'>
            <FormTab label='Dream Home'>
              <CompetitionTable url='competitions' competition='DREAMHOME' />
            </FormTab>
            <FormTab label='Lifestyle Prizes'>
              <CompetitionTable url='competitions' competition='PRIZE' />
            </FormTab>
            <FormTab label='Fixed Odds'>
              <CompetitionTable url='competitions' competition='FIXED_ODDS' />
            </FormTab>
            <FormTab label='Weekly Subscription'>
              <CompetitionTable
                url='competitions'
                competition='WEEKLY_SUBSCRIPTION_DRAW'
              />
            </FormTab>
          </TabbedForm>
        </Card>
      </Box>
    </>
  );
};

export default CompetitionsList;
